<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row" v-if="formData.id && formData.isHub == 1">
      <div class="col-12" style="top: -15px; position: relative">
        <q-tabs v-model="tab">
          <q-tab name="general" label="General" />
          <q-tab name="chains" label="Chains" />
        </q-tabs>
      </div>
    </div>
    <div v-if="tab == 'general'" class="row items-center">
      <div
        class="col-12 q-mb-sm"
        v-if="
          formData.hasOwnProperty('id') && currentUserData.role == 'superAdmin'
        "
      >
        <q-btn
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          :loading="keyRegenLoading"
          @click="keyRegen"
        >
          <q-icon size="xs" name="mdi-refresh" class="q-mr-sm"></q-icon>
          Re-generate Key
        </q-btn>
        <q-btn
          v-if="formData.isHub == 1"
          class="q-ml-sm"
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          :loading="keyRegenLoading"
          @click="keyRegenRockblock"
        >
          <q-icon size="xs" name="mdi-refresh" class="q-mr-sm"></q-icon>
          Re-generate RockBlock Key
        </q-btn>
      </div>
      <div
        v-if="
          !formData.hasOwnProperty('id') && currentUserData.role == 'superAdmin'
        "
        class="col-12 q-px-sm"
      >
        <assignApplication
          :id="formData.applications_id"
          @changed="val => (formData.applications_id = val)"
        />
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <assignDevice
          :id="formData.parentKey"
          label="Parent Device"
          @changed="val => (formData.parentKey = val)"
        />
      </div>

      <div class="col-12 col-sm-6 q-px-sm">
        <q-input hint v-model="formData.pcb_id" label="PCB ID"></q-input>
      </div>
      <div
        v-if="
          ['superAdmin', 'appAdmin', 'orgAdmin'].includes(currentUserData.role)
        "
        class="col-12 q-px-sm"
      >
        <assignDeviceType
          :id="formData.type_id"
          label="Device Type"
          @changed="val => (formData.type_id = val)"
        />
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input
          hint
          v-model="formData.batteryThresholdOverride"
          label="Battery Threshold Override"
        ></q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input
          hint
          v-model="formData.heartbeatThresholdOverride"
          label="Heartbeat Threshold Override"
        ></q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input hint v-model="formData.version" label="Version"></q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input hint v-model="formData.sim" label="SIM"></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          type="textarea"
          v-model="formData.comment"
          label="Comment"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-select
          v-model="formData.imageRotation"
          label="Image Rotation"
          emit-value
          map-options
          :options="[
            {
              label: '0 - No Rotation',
              value: 0
            },
            {
              label: '90 - Rotate 90 degrees',
              value: 90
            },
            {
              label: '180 - Rotate 180 degrees',
              value: 180
            },
            {
              label: '270 - Rotate 270 degrees',
              value: 270
            }
          ]"
        ></q-select>
      </div>

      <div class="col-12 col-sm-6 q-px-none q-mt-md">
        <q-checkbox
          dense
          v-model="formData.isHub"
          :true-value="1"
          :false-value="0"
          :toggle-indeterminate="false"
          label="Device is a Hub"
          @input="loadHubData"
        ></q-checkbox>
      </div>
      <div
        v-if="
          formData.hasOwnProperty('id') && currentUserData.role == 'superAdmin'
        "
        class="col-12 col-sm-6 q-px-none q-mt-md"
      >
        <q-checkbox
          dense
          v-model="formData.mirror"
          :true-value="1"
          :false-value="0"
          :toggle-indeterminate="false"
          label="Mirror Device"
        ></q-checkbox>
      </div>
      <div class="col-12 col-sm-6 q-px-none q-mt-md">
        <q-checkbox
          dense
          v-model="formData.overlaysEnabled"
          :true-value="1"
          :false-value="0"
          :toggle-indeterminate="false"
          label="Overlay Enabled"
        ></q-checkbox>
      </div>
    </div>
    <div v-if="tab == 'chains'" class="row items-center">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          {{ addChain ? "New " : "" }}Chain{{
            editChain || addChain ? "" : "s"
          }}
          {{ editChain ? editChainData.descriptor : "" }}
          <q-btn
            class="q-ml-md"
            color="secondary"
            text-color="accent"
            unelevated
            no-caps
            v-if="!editChain && !addChain"
            @click="addChain = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="accent"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>
          <q-btn
            icon="mdi-close"
            flat
            class="float-right"
            v-if="editChain || addChain"
            @click="
              editChain = false;
              addChain = false;
            "
          ></q-btn>
        </h6>
      </div>
      <div
        v-if="!editChain && !addChain"
        class="col-12 mt-0 pt-0"
        style="height: calc(100vh - 560px) !important"
      >
        <datatable
          ref="dataTable"
          :filter="search"
          :flat="true"
          :data="hubChains"
          :columns="columns"
          @rowDoubleClick="chainDoubleClicked"
        >
        </datatable>
      </div>
      <div v-if="editChain" class="col-12">
        <chain-form :data="editChainData"> </chain-form>
      </div>
      <div v-if="addChain" class="col-12">
        <chain-form
          :data="{ devices_id: formData.id }"
          @close="addChain = false"
        >
        </chain-form>
      </div>
    </div>
    <div v-if="!editChain && !addChain" class="row items-center q-pt-md">
      <div class="col-12">
        <q-btn
          @click="save()"
          :loading="saveLoading"
          color="primary"
          no-caps
          class="float-right"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save
        </q-btn>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignApplication from "@/components/applications/assignApplication.vue";
import datatable from "@/components/datatable/datatable.vue";
import assignDevice from "@/components/devices/assignDevice.vue";
import assignDeviceType from "@/components/deviceTypes/assignDeviceType.vue";
import chainForm from "@/components/devices/chainForm.vue";

export default {
  components: {
    assignApplication,
    assignDevice,
    datatable,
    chainForm,
    assignDeviceType
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteData: "settings/siteData",
      hubChains: "devices/hubChainList"
    })
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      isHub: 0,
      overlaysEnabled: 0
    },
    keyRegenLoading: false,
    tab: "general",
    saveLoading: false,

    // HUB CHAINS
    search: "",
    columns: [
      {
        name: "id",
        label: "Chain ID",
        align: "left",
        field: "id",
        sortable: true
      },
      {
        name: "descriptor",
        label: "Descriptor",
        align: "left",
        field: "descriptor",
        sortable: true
      },
      {
        name: "pos",
        label: "Chain Position",
        align: "left",
        field: "pos",
        sortable: true
      }
    ],
    editChain: false,
    editChainData: null,
    addChain: false
  }),
  beforeCreate() {
    this.$store.dispatch("applications/loadAll");
    this.$store.dispatch("deviceTypes/loadAll");
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        this.formData.isHub == null ? 0 : 1;
        this.loadHubData();
      } else {
        this.formData = {
          isHub: 0,
          overlaysEnabled: 0
        };
      }
    },
    loadHubData() {
      if (this.formData.isHub == 1) {
        this.$store.dispatch("devices/loadHubChains", this.formData.id);
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then(result => {
          if (result) {
            if (this.currentUserData.role != "superAdmin") {
              this.formData.applications_id = this.siteData.id;
            }
            this.$store.dispatch("devices/new", this.formData).then(result => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "info",
                  message: result.Response.MessageK,
                  timeout: 0
                });
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.saveLoading = true;
      setTimeout(() => {
        this.$store.dispatch("devices/save", this.formData).then(result => {
          this.saveLoading = false;
          if (result.Result == "Success") {
            this.loadHubData();
            // this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: result.Response.Message
            });
          }
        });
      });
    },
    keyRegen() {
      this.keyRegenLoading = true;
      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("devices/keyRegen", { id: this.formData.id })
            .then(result => {
              this.keyRegenLoading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "info",
                  message: result.Response.MessageK,
                  timeout: 0
                });
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
        } else {
          this.keyRegenLoading = false;
        }
      });
    },
    keyRegenRockblock() {
      this.keyRegenLoading = true;
      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("devices/keyRegenRockblock", { id: this.formData.id })
            .then(result => {
              this.keyRegenLoading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "info",
                  message: result.Response.MessageK,
                  timeout: 0
                });
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
        } else {
          this.keyRegenLoading = false;
        }
      });
    },

    // HUB CHAINS
    chainDoubleClicked(row) {
      this.editChainData = row;
      this.editChain = true;
    }
  }
};
</script>
